import { isProduction } from 'util/getEnv';

export const ENV_TRANSFER_PARAM = 'envData';
export const ENV_SESSION_KEY = 'environment';

export const applyEnvFromUrl = () => {
  if (isProduction()) return;

  try {
    const params = new URLSearchParams(window.location.search);
    const envData = params.get(ENV_TRANSFER_PARAM);
    if (!envData) return;

    sessionStorage.setItem(ENV_SESSION_KEY, envData);
    window.history.replaceState(
      null,
      '',
      window.location.pathname + window.location.hash,
    );
  } catch (e) {
    /* malformed/tampered param — ignore and continue with defaults */
  }
};

applyEnvFromUrl();
